import React, { useEffect, useState } from "react";
import "./Movies.css";
import VideoPlayer from "./Videoplayer";

const movieData = [
  {
    title: "The Matrix",
    description: "A hacker discovers the world is a simulation.",
    image: "https://via.placeholder.com/300x170?text=Matrix",
    videoUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    title: "Inception",
    description: "A thief enters dreams to steal secrets.",
    image: "https://via.placeholder.com/300x170?text=Inception",
    videoUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
  {
    title: "Interstellar",
    description: "Explorers travel through a wormhole to save humanity.",
    image: "https://via.placeholder.com/300x170?text=Interstellar",
    videoUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
  },
];

const Movies = ({ handleExit }) => {
  const [focusedIndex, setFocusedIndex] = useState(0);
  const [playingVideo, setPlayingVideo] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const key = e.keyCode;

      if (!playingVideo) {
        switch (key) {
          case 37: // LEFT
            handleExit("sidebar");
            break;
          case 38: // UP
            setFocusedIndex((prev) => Math.max(prev - 1, 0));
            break;
          case 40: // DOWN
            setFocusedIndex((prev) => Math.min(prev + 1, movieData.length - 1));
            break;
          case 13: // ENTER
            setPlayingVideo(movieData[focusedIndex].videoUrl);
            break;
          default:
            break;
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [focusedIndex, playingVideo, handleExit]);

  return (
    <div className="movies-container">
      <h2 className="movies-heading">🎬 Movie Collection</h2>

      <div className="movies-list">
        {movieData.map((movie, idx) => (
          <div
            key={idx}
            className={`movie-card ${focusedIndex === idx ? "focused" : ""}`}
          >
            <img src={movie.image} alt={movie.title} className="movie-image" />
            <div className="movie-info">
              <h3 className="movie-title">{movie.title}</h3>
              <p className="movie-description">{movie.description}</p>
            </div>
          </div>
        ))}
      </div>

      {playingVideo && (
        <VideoPlayer  videoUrl={playingVideo} onClose={() => setPlayingVideo(null)} />
      )}
    </div>
  );
};

export default Movies;
